import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

const flexCenter = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

export const styles = ({ palette, spacing }: Theme) => createStyles({
    background: {
        backgroundColor: palette.primary.light
    },
    container: {
        maxWidth: "500px",
        margin: "0 auto",
        paddingTop: spacing.unit * 2,
        paddingBottom: spacing.unit * 2,
    },
    iconButton: {
        marginRight: spacing.unit,
        marginLeft: spacing.unit
    },
    links: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        "& a" : {
            color: "inherit",
            textDecoration: "none",
            "&:hover" : {
                textDecoration: "none"
            }
        }
    },
    socials: {
        ...flexCenter,
        borderTop: `1px solid ${palette.primary.main}`
    }
});


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.style.tsx